<template>
  <div class="mt-5">
    <h5 class="section-container text-center pt-3">
      <strong>PRE</strong>
    </h5>

    <div class="col-12 px-0 border-bottom">
      <scale-question
        :id="preQuestion.id"
        v-model="selectedNumericAnswer"
        :number-label="preQuestion.numberLabel"
        :text="preQuestion.text"
        :scales="preQuestion.answers"
        :disabled="disabled"
        @onSelectedNumericAnswer="onNumericAnswerChanged"
      />

      <div class="row">
        <div class="col-md-12 ml-5 mt-3">
          <strong>Evidencia para {{ preQuestion.numberLabel }}</strong>
        </div>
      </div>
      <div class="row mt-n3">
        <div class="col-md-12 ml-5 mt-3">
          <div class="row mb-3">
            <div class="col-md-4 col-sm-12">
              <label>Fuente:</label>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomDropDown
                  v-model="selectedDiscipline"
                  placeholder="Seleccionar"
                  fieldkey="id"
                  fieldname="disciplineName"
                  :disabled="disabled"
                  :options="evidences"
                  :error="errors[0]"
                  :custom-error-msg="errorMsgs['SelectSource']"
                  @input="onDisciplineChanged"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-2 col-sm-12">
              <label>Fecha:</label>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomDatePicker
                  :id="`$evidenceDate${questionId}`"
                  v-model="evidenceDate"
                  required="required"
                  :max-date="disabledDates"
                  :disabled="disabled && preQuestion.evidenceDate"
                  :error="errors[0]"
                  :custom-error-msg="errorMsgs['SelectDate']"
                  @onSelectedDate="onEvidenceDate"
                />
              </ValidationProvider>
            </div>
          </div>
          <div class="row mr-5">
            <div class="col w-100">
              <label>Resumen de resultados relevantes:</label>
              <ValidationProvider v-slot="{ errors }" slim rules="required">
                <CustomTextArea
                  v-show="true"
                  :id="`$resumeRelevantResults${questionId}`"
                  v-model="preQuestion.evidenceNote"
                  :maxlength="maxchars"
                  :classes="['eq-field']"
                  :disabled="disabled"
                  :error="errors[0]"
                  :custom-error-msg="errorMsgs['ResumeRelevantResult']"
                  :required="true"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/component/radio-button.css"></style>
<style scoped>
h1 {
  font-weight: bold;
  font-size: 1.2em;
}
.main-container-for-pre {
  margin-bottom: 5px;
}
.section-container {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
  height: 59px;
}
</style>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import ScaleQuestion from '@/components/pei/evaluations/serviceintervention/components/ScaleQuestion';
export default {
  name: 'PreQuestion',
  components: {
    CustomDropDown,
    ValidationProvider,
    CustomTextArea,
    CustomDatePicker,
    ScaleQuestion,
  },
  data() {
    return {
      test: null,
      selectedDiscipline: this.getAlreadySelectedDiscipline(),
      selectedNumericAnswer: this.getNumericAnswer(),
      maxchars: 500,
      evidenceDate: this.getEvidenceDate(),
      errorMsgs: {
        SelectSource: 'Favor seleccione',
        SelectDate: 'Fecha requerida',
        ResumeRelevantResult: ' Campo Requerido',
      },
      disabledDates: new Date(Date.now()),
    };
  },
  props: {
    questionId: {
      type: Number,
      required: true,
    },
    preQuestion: {
      type: Object,
      default: () => {},
    },
    evidences: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    getEvidenceDate() {
      if (this.preQuestion && this.preQuestion.evidenceDate) {
        return new Date(this.preQuestion.evidenceDate);
      }
    },
    getAlreadySelectedDiscipline() {
      return this.preQuestion
        ? this.evidences.find((x) => x.id === this.preQuestion.evidenceSourceId)
        : null;
    },
    getNumericAnswer() {
      let selectedNumericValue = this.preQuestion.answers.find(
        (x) => x.id == this.preQuestion.questionnaireAnswerId
      );
      const result = {
        id:
          this.preQuestion.questionnaireAnswerId != null
            ? this.preQuestion.questionnaireAnswerId
            : 0,
        text:
          selectedNumericValue != undefined ? selectedNumericValue.text : '',
      };

      return result.id > 0 ? result : null;
    },
    onEvidenceDate(data) {
      if (data) this.preQuestion.evidenceDate = data;
    },
    onNumericAnswerChanged(answerId) {
      if (answerId > 0) {
        this.preQuestion.questionnaireAnswerId = answerId;
        this.preQuestion.answerNumericValue = Number(
          this.preQuestion.answers.find((x) => x.id == answerId).text
        );
      }
    },
    onDisciplineChanged(data) {
      if (data) this.preQuestion.evidenceSourceId = data.id;
    },
    onAnwerSelected(value) {
      if (value) {
        this.selectedNumericAnswer = value;
        this.preQuestion.questionnaireAnswerId = value.id;
        this.preQuestion.answerNumericValue = Number(value.text);
      }
    },
  },
};
</script>
